import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-crearmetavendedores',
  templateUrl: './crearmetavendedores.component.html',
  styleUrls: ['./crearmetavendedores.component.css']
})
export class CrearmetavendedoresComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<CrearmetavendedoresComponent>) { }

  ngOnInit(): void {
  }

  cerrar(): void {
    this.dialogRef.close();
  }

}
